$(function () {
// 	checkCookie();

	$(".cookie-close").on("click", notAcceptCookie);

	$(".cookie-btns__settings").on("click", popFire);
	$(".cookie-btns__accept").on("click", acceptCookie);
  
	//  REGISTER PAGE
    $('#professional').click(function() {
      if($('#professional').is(':checked')) { 
        $('.license').removeClass('hide');
      } 
    });

    $('#customer').click(function() {
         if($('#customer').is(':checked')) { 
           $('.license').addClass('hide');
         } 
      });
    });

const checkCookie = () => {
	let cookieAccepted = getCookie("cookieShown");

	if (cookieAccepted) {
		console.log("cookie found. no action necessary");
		return;
	} else {
		setTimeout(function () {
			$("#twc-cookie").slideDown();
		}, 500);
	}
};

const notAcceptCookie = () => {
	setCookie("cookieShown", "cookie", 1);
	popClose();
  	console.log('cookie set for a day');
};

const acceptCookie = () => {
	setCookie("cookieShown", "cookie", 365);
	popClose();
	console.log("cookie set for whole year");
};

// set up cookie
const setCookie = (name, value, day) => {
	var expires = "";
	if (day) {
		var date = new Date();
		date.setTime(date.getTime() + day * 24 * 60 * 60 * 1000);
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

const getCookie = (name) => {
	var nameEQ = name + "=";
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
};

const popFire = () => {
	$("#pop .pop-con").show();
	$("#pop").fadeIn(500);
	$("#dim").fadeIn(500);
};

const popClose = () => {
	$("#twc-cookie").slideUp();
	$("#pop").fadeOut(400);
	$("#dim").fadeOut(400);
	$("#cookie-con").fadeOut(400);
};